:host {
  display: none;
}

:host([active]) {
  display: block;
}

.wizard-panel {
  width: 100%;
}

.wizard-panel-content {
  width: 100%;
}
